(function(config) {
    'use strict';

    angular.module('holiday.services', [
            'ngResource',
        ])
        .factory('holidayDataSrvc', holidayDataSrvc)
    	.factory('holidaySrvc', holidaySrvc);

        holidayDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

        function holidayDataSrvc($resource, transformRequestSrvc) {
            return $resource(config.api + '/api/v1/holidays/:pk/', { pk: '@pk' }, {
                get: {
                    method: 'GET'
                },
                list: {
                    method: 'GET',
                    isArray: true
                },
                create: {
                    method: 'POST',
                    headers: { 'Content-Type': undefined },
                    transformRequest: transformRequestSrvc.formDataTransform
                },
                update: {
                    method: 'PATCH',
                    headers: { 'Content-Type': undefined },
                    transformRequest: transformRequestSrvc.formDataTransform
                },
                delete: {
                    method: 'DELETE'
                }
            });
        }

        holidaySrvc.$inject = ['holidayDataSrvc'];

        function holidaySrvc(holidayDataSrvc) {

            return {
                remove: remove,
            };

            function remove(id, successCallback, errorCallback) {
                holidayDataSrvc.delete({
                    pk: id
                }).$promise.then(successCallback, errorCallback);
            }
        }

})(window.config);
